export default "__VITE_ASSET__d182d977__$_?nuxt_component=async__"